import { FormattedMessage, useIntl } from 'react-intl'

import { Alert } from '@gto/ui/alert'

type InlineQueryErrorProps = {
  /** i18n id for the user-facing error body. Sentry sees the raw error elsewhere. */
  messageId: string
  onRetry: () => void
  'data-tst'?: string
}

/**
 * Inline error + retry for a query so a failed fetch never renders a perpetual
 * loading/empty (or a fake zero-valued) state. The app has no SnackbarProvider,
 * so this inline Alert — not a toast — is the user-visible surface for query
 * failures across the admin pages.
 */
export const InlineQueryError = ({
  messageId,
  onRetry,
  'data-tst': dataTst,
}: InlineQueryErrorProps) => {
  const { formatMessage } = useIntl()

  return (
    <Alert
      data-tst={dataTst}
      message={<FormattedMessage id={messageId} />}
      severity="error"
      actions={[
        {
          children: formatMessage({ id: 'admin.error.retry' }),
          onClick: onRetry,
        },
      ]}
    />
  )
}
